import type { Capability } from "owa-capabilities";
import type { MailboxInfo } from "owa-client-types";
import { isServiceRequestSupportedForMailbox } from "owa-service/lib/utils/isServiceRequestSupportedForMailbox";
import { isMailboxSharedOrDelegate } from "owa-account-shared-mailbox-utils";

/**
 * NOTE: Please see the README for more information on how the
 * capability functions must be implemented and used.
 *
 * This capability is being used to determine if the outlook favorites service should be called
 */
export const favoritesRoamingCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        return true; // by default
    },
    isSupported: (mailboxInfo?: MailboxInfo) => {
        if (mailboxInfo) {
            const isShared = isMailboxSharedOrDelegate(mailboxInfo);
            const isPst = !isServiceRequestSupportedForMailbox(mailboxInfo);
            // In order to access the favorites service make sure it's not shared, delegate or explicit logon
            // and that it's not a PST mailbox which does not support service requests
            return !isShared && !isPst;
        }
        return false;
    },
};
